var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { makeAutoObservable, runInAction } from 'mobx';
import _ from 'lodash';
import { settingsService } from 'ziphy-web-shared/basic/api';
class SettingsStore {
    constructor() {
        this.enums = {};
        this.options = [];
        this.tosVersions = {};
        this.symptomCategories = {};
        makeAutoObservable(this);
    }
    // Computed
    get optionsByScope() {
        return _.groupBy(this.options, 'scope');
    }
    // Actions
    read(params, options) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield settingsService.read(params, Object.assign(Object.assign({}, options), { cacheTime: 900 }));
            if (!response.error) {
                runInAction(() => {
                    var _a, _b, _c, _d;
                    if ((_a = response.prepared) === null || _a === void 0 ? void 0 : _a.tosVersions) {
                        this.tosVersions = (_b = response.prepared) === null || _b === void 0 ? void 0 : _b.tosVersions;
                    }
                    if ((_c = response.prepared) === null || _c === void 0 ? void 0 : _c.symptomCategories) {
                        this.symptomCategories = (_d = response.prepared) === null || _d === void 0 ? void 0 : _d.symptomCategories;
                    }
                });
            }
            return response;
        });
    }
    readEnums(params, options) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield settingsService.readEnums(params, Object.assign({ cacheTime: 900 }, options));
            if (!response.error && !response.isFromCache) {
                runInAction(() => {
                    if (response.prepared) {
                        this.enums = response.prepared;
                    }
                });
            }
            return response;
        });
    }
    readOptions(params, options) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield settingsService.readOptions(params, Object.assign({ cacheTime: 900 }, options));
            if (!response.error && !response.isFromCache) {
                runInAction(() => {
                    var _a, _b;
                    if (response.prepared) {
                        this.options = ((_b = (_a = response.prepared) === null || _a === void 0 ? void 0 : _a.options) === null || _b === void 0 ? void 0 : _b.items) || [];
                    }
                });
            }
            return response;
        });
    }
    init() {
        return __awaiter(this, void 0, void 0, function* () {
            yield Promise.all([
                this.read(),
                this.readEnums(),
                //
            ]);
        });
    }
}
export const $settings = new SettingsStore();
